import { getApolloClient } from '@/utils/apollo-client';
import Router, { NextRouter } from 'next/router';
import { LogoutDocument } from '@/generated/graphql';

export async function logout(): Promise<void> {
  const apolloClient = getApolloClient();

  await apolloClient.mutate({
    mutation: LogoutDocument,
  });

  await apolloClient.clearStore();
  localStorage.removeItem('authExpires');
}

// The one place that builds the /signin redirect. Router encodes query values
// itself — pre-encoding the returnUrl double-encodes it, and signin then
// redirects to a literal "/%2Fp%2F..." path (404).
export function redirectToSignin(
  router: Pick<NextRouter, 'push' | 'asPath' | 'isReady'>,
): void {
  // Before hydration completes, a statically-optimized dynamic route reports
  // asPath as the bracketed route pattern ("/p/[pid]/..."), which would
  // poison returnUrl and crash the post-login push. Render-time callers
  // re-render when isReady flips, so the redirect still fires.
  if (!router.isReady) return;
  router.push({
    pathname: '/signin',
    query: { returnUrl: router.asPath },
  });
}

// Responsible for reauthenticating a user if their cookie expires
export async function reauthenticate(): Promise<void> {
  await logout();
  redirectToSignin(Router);
}

export function checkAuth(): void {
  const expiration = localStorage.getItem('authExpires');
  if (expiration && Date.now() >= Number(expiration) + 60000) {
    reauthenticate();
  }
}
